mutation CreateMultipleContents($input: [CreateContentInput!]!) {
  createMultipleContents(input: $input) {
    id
    title
  }
}
